export default "__VITE_ASSET__Bx1pJk35__"